import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { Steps } from 'venuescanner-js/react/components/Inbox/components/Summary/components/Steps/Steps';
import { ConfirmPay } from 'venuescanner-js/react/components/Inbox/components/Summary/components/ConfirmPay/ConfirmPay';
import { PlantATree } from 'venuescanner-js/react/components/Inbox/components/Summary/components/PlanATree/PlantATree';
import { CustomersLove } from 'venuescanner-js/react/components/Inbox/components/Summary/components/CustomersLove/CustomersLove';
import { RareFind } from 'venuescanner-js/react/components/Inbox/components/Summary/components/RareFind/RareFind';
import { ContactButton } from 'venuescanner-js/react/components/Inbox/components/Summary/components/ContactButton/ContactButton';
import { PaymentSummary } from 'venuescanner-js/react/components/Inbox/components/Summary/components/PaymentSummary/PaymentSummary';
import './Summary.scss';
import { createCheckoutSession } from './queries';

const BottomOptions = ({ isMobileDevice, venue }) => {
  return (
    <div className='bottom-widgets'>
      <div className='bottom-widgets__container'>
        <PlantATree isMobileDevice={isMobileDevice} venue={venue} />
        <CustomersLove isMobileDevice={isMobileDevice} venue={venue} />
        <ContactButton isMobileDevice={isMobileDevice} venue={venue} />
      </div>
    </div>
  );
};

export const Summary = ({ venue, thread, isMobileDevice, space }) => {
  const { isFetching, data, isSuccess, refetch } = useQuery(
    ['checkoutSession', thread._id.toString()],
    () => createCheckoutSession(thread),
    { enabled: false, useErrorBoundary: true },
  );

  const { cumulativeOffer } = thread;

  const onClick = async () => {
    refetch();
  };

  useEffect(() => {
    if (isSuccess) {
      const { url } = data;
      window.location.assign(url);
    }
  }, [data, isSuccess]);

  return (
    <div className='inbox__section summary-page'>
      <div className='summary-page_container'>
        <div className='summary-page_container_l-column'>
          <Steps thread={thread} />
          <ConfirmPay
            paymentMethod={'online'}
            cumulativeOffer={cumulativeOffer}
          />
          <RareFind thread={thread} />
          {!isMobileDevice && (
            <>
              <div className='summary-page_container_l-column--badge-container'>
                <PlantATree venue={venue} />
                <CustomersLove venue={venue} />
              </div>
              <ContactButton venue={venue} />
            </>
          )}
        </div>
        <div className='summary-page_container_r-column'>
          <PaymentSummary
            thread={thread}
            venue={venue}
            space={space}
            onClick={onClick}
            isLoading={isFetching}
          />
          {isMobileDevice && <BottomOptions venue={venue} isMobileDevice />}
        </div>
      </div>
    </div>
  );
};
